import { render } from "./EditPayment2.vue?vue&type=template&id=3ab4e13c"
import script from "./EditPayment2.vue?vue&type=script&lang=js"
export * from "./EditPayment2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__